//Error Handling Reducer

const errorHandlerReducerDefaultState = {
    code    : undefined,
    message : '',
    type    : ''
};

export default (state = errorHandlerReducerDefaultState, action) => {
    switch(action.type) {
        case 'SET_ERROR_STATE':
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/Reducers/errorHandler.js